import { Icono } from '../componentes/Icono';
import type { EntradaMenu } from '../logica/navegacion';
import { dibujoDe } from './iconosMenu';

/**
 * Lo que va dentro de la pantalla de una entrada (G130, `parent_key`): sus apartados (`section`) y sus tarjetas
 * (`card`), en el orden de la API. Mientras la pantalla de la madre no llegue con su módulo (p. ej. «Negocio», 1.14),
 * cada una se pinta como una tarjeta que lleva a su ruta; el apartado abierto, marcado. La pantalla de la madre decidirá
 * después cómo pinta los apartados (su barra de apartados) sin que cambie la API.
 */
export function Anidadas({ madre, anidadas, abierta, onIr }: { madre: EntradaMenu; anidadas: readonly EntradaMenu[]; abierta: EntradaMenu | null; onIr: (e: EntradaMenu) => void }) {
    return (
        <div role="list" aria-label={madre.etiqueta} className="rv-anidadas">
            {anidadas.map((e) => (
                <button
                    key={e.clave}
                    type="button"
                    role="listitem"
                    className="rv-anidada"
                    aria-current={abierta?.clave === e.clave ? 'page' : undefined}
                    onClick={() => {
                        onIr(e);
                    }}
                >
                    <span className="rv-anidada__baldosa">
                        <Icono nombre={dibujoDe(e.icono)} />
                    </span>
                    <span className="rv-anidada__texto">{e.etiqueta}</span>
                    {e.noContratada ? <i className="icon-plus" aria-label="No contratado" /> : <Icono nombre="chevron-right" />}
                </button>
            ))}
        </div>
    );
}
